import React, { useEffect, useState } from 'react';
import * as api from '../../billMemory/api';
import { checkRowText, lastSavesText } from '../../billMemory/client';
import RevertLineButton from './RevertLineButton';

/**
 * Check (Fix plan, I3): the rows Bill Memory filled this week that the business is asked to check first — the
 * riskiest half of the weekly sample. Right or Wrong; a Wrong counts at once, corrects what was learned and
 * offers to revert that line (I4). Owner and Managers (the server enforces it).
 */
export default function CheckTab() {
  const [rows, setRows] = useState(null);
  const [done, setDone] = useState({}); // sample_id → { verdict, revert }
  useEffect(() => {
    Promise.resolve(api.getCheck()).then((r) => setRows((r && r.rows) || [])).catch(() => setRows([]));
  }, []);
  const mark = async (r, verdict) => {
    try {
      const out = await api.markCheck(r.sample_id, verdict);
      setDone((d) => ({ ...d, [r.sample_id]: { verdict, revert: out && out.revert } }));
    } catch (e) {
      setDone((d) => ({ ...d, [r.sample_id]: { error: (e && e.message) || 'That was refused.' } }));
    }
  };
  if (!rows) return <div className="bm-note">Loading…</div>;
  if (!rows.length) return <div className="bm-note">Nothing to check this week.</div>;
  return (
    <ul className="bm-log">
      {rows.map((r) => {
        const d = done[r.sample_id];
        return (
          <li key={r.sample_id}>
            <div>{checkRowText(r)}</div>
            {lastSavesText(r) && <div className="bm-note">{lastSavesText(r)}</div>}
            {!d || d.error ? (
              <span>
                <button type="button" className="irr-secondary-btn" onClick={() => mark(r, 'right')}>Right</button>{' '}
                <button type="button" className="irr-secondary-btn" onClick={() => mark(r, 'wrong')}>Wrong</button>
                {d && d.error && <span className="bm-note">{` ${d.error}`}</span>}
              </span>
            ) : (
              <span>
                <span className="bm-note">{d.verdict === 'right' ? 'Marked right. ' : 'Marked wrong — Bill Memory will ask about this name again. '}</span>
                {d.verdict === 'wrong' && <RevertLineButton revert={d.revert} />}
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
}
